module.exports = __webpack_public_path__ + "a31b5d97.jpg";